import {
  DeleteOutlined,
  PlusOutlined,
  SaveOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { CreateAttribute } from "src/enitities/Form";

const modalHeaderStyle = {
  borderBottom: "1px solid #f0f0f0",
  paddingBottom: "12px",
};

const AttributesNomenclature = ({ record, token }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [newAttribute, setNewAttribute] = useState(null);
  const [attributesTypes, setAttributesTypes] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleSetAttributes = () => {
    axios
      .get(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/${record.id}/attributes?token=${token}`
      )
      .then((res) => setAttributes(res.data.attributes));
  };

  useEffect(() => {
    if (isOpen) {
      axios
        .get(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/${record.id}/attributes?token=${token}`
        )
        .then((res) => setAttributes(res.data.attributes));
    } else {
      setAttributes([]);
      setNewAttribute(null);
    }
  }, [isOpen, token, record.id]);

  useEffect(() => {
    if (isOpen || !drawerVisible) {
      axios
        .get(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes/types?token=${token}`
        )
        .then((res) => setAttributesTypes(res.data));
    }
  }, [isOpen, drawerVisible, token]);

  const handleAddNew = () => {
    setNewAttribute({ id: "new", attribute_id: null, values: "" });
  };

  const handleInputChange = (key, value) => {
    setNewAttribute((prev) => ({ ...prev, [key]: value }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSaveNew();
    }
  };

  const handleSaveNew = async () => {
    if (!newAttribute?.attribute_id || !newAttribute?.values.trim()) return;

    try {
      await axios.post(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes/add?token=${token}`,
        {
          nomenclature_id: record.id,
          attributes: [
            {
              attribute_id: newAttribute.attribute_id,
              value: newAttribute.values,
            },
          ],
        }
      );
      handleSetAttributes();
      setNewAttribute(null);
    } catch (error) {
      message.error(error.detail);
      console.error("Ошибка при сохранении атрибута:", error);
    }
  };

  const handleCreateNewType = () => {
    setDrawerVisible(true);
  };

  const handleDeleteType = async (id) => {
    try {
      await axios.delete(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes?token=${token}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: [id],
        }
      );
      setAttributesTypes((prev) => prev.filter((type) => type.id !== id));
      handleSetAttributes();
    } catch (error) {
      console.error("Ошибка удаления типа атрибута", error);
    }
  };

  const handleDeleteAttribute = async (id) => {
    try {
      await axios.delete(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes/del?token=${token}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: [id],
        }
      );
      handleSetAttributes();
    } catch (error) {
      console.error("Ошибка удаления атрибута", error);
    }
  };

  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      render: (text, row) =>
        row.id === "new" ? (
          <Select
            value={newAttribute.attribute_id}
            onChange={(value) => handleInputChange("attribute_id", value)}
            style={{ width: "100%" }}
            optionRender={(option) => (
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {option.label}
                {/* <EditAttribute token={token} record={option} /> */}
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteType(option.value)}
                />
              </Space>
            )}
            dropdownRender={(menu) => (
              <div>
                {menu}
                <Button
                  type="text"
                  icon={<PlusOutlined />}
                  onClick={handleCreateNewType}
                  style={{ width: "100%", textAlign: "left", padding: "8px" }}
                >
                  Создать новый тип
                </Button>
              </div>
            )}
            options={attributesTypes.map((type) => ({
              value: type.id,
              label: type.name,
            }))}
          />
        ) : (
          text
        ),
    },
    {
      title: "Значение",
      dataIndex: "values",
      key: "values",
      render: (text, row) =>
        row.id === "new" ? (
          <Input
            value={newAttribute.values}
            onChange={(e) => handleInputChange("values", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        ) : (
          text
        ),
    },
    {
      title: "Действие",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, row) =>
        row.id === "new" ? null : (
          <Button
            onClick={() => handleDeleteAttribute(row.id)}
            icon={<DeleteOutlined />}
          />
        ),
    },
  ];

  return (
    <>
      <Tooltip title="Атрибуты номенклатуры">
        <Button icon={<TagsOutlined />} onClick={() => setIsOpen(true)} />
      </Tooltip>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width={1200}
        title={
          <div style={modalHeaderStyle}>Управление атрибутами номенклатуры</div>
        }
      >
        <Button
          type="dashed"
          icon={newAttribute ? <SaveOutlined /> : <PlusOutlined />}
          onClick={newAttribute ? handleSaveNew : handleAddNew}
          style={{ width: "100%", marginTop: "10px" }}
        >
          {newAttribute ? "Сохранить атрибут" : "Добавить атрибут"}
        </Button>
        <Table
          dataSource={newAttribute ? [...attributes, newAttribute] : attributes}
          rowKey="id"
          columns={columns}
          pagination={false}
        />
      </Modal>
      <CreateAttribute
        visible={drawerVisible}
        setVisible={setDrawerVisible}
        token={token}
      />
    </>
  );
};

export default AttributesNomenclature;
